module.exports = "/_next/static/images/photoGlebReznicenco-87d1b7475f441b986e43c01c38fb52b1.webp";